import React, { useEffect } from "react";

import ReachOutNow from "./ReachOut";
import EventsCards from "./EventsCards";
import Footer from "../pages/footer";

import "../App.css";
import "../styles/Events-Culture-shifts.css";

export default function EventsCultureShifts() {
  /* =========================================================
     PAGE LOAD
  ========================================================= */

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  /* =========================================================
     SCROLL HELPERS
  ========================================================= */

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const scrollToLinkedIn = () => {
    document
      .getElementById("linkedin-live-feed")
      ?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
  };

  return (
    <div className="events-page">
      <ReachOutNow />

      {/* =====================================================
          FLOATING NAVIGATION
      ====================================================== */}

      <div className="events-floating-navigation">
        <button
          type="button"
          className="events-floating-button"
          onClick={scrollToTop}
          aria-label="Scroll to top"
        >
          <svg
            viewBox="0 0 20 20"
            aria-hidden="true"
          >
            <path
              d="M5 12.5L10 7.5L15 12.5"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        <button
          type="button"
          className="events-floating-button"
          onClick={scrollToLinkedIn}
          aria-label="View latest updates"
        >
          <svg
            viewBox="0 0 20 20"
            aria-hidden="true"
          >
            <path
              d="M5 7.5L10 12.5L15 7.5"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>

      {/* =====================================================
          HERO
      ====================================================== */}

      <section className="events-hero">
        <div
          className="events-hero-background"
          aria-hidden="true"
        >
          <img
            src="/assets/GISHWEvent.jpg"
            alt=""
            className="events-hero-image"
          />

          <div className="events-hero-overlay" />

          <span className="events-hero-glow events-hero-glow-left" />
          <span className="events-hero-glow events-hero-glow-right" />

          <span className="events-hero-orbit events-hero-orbit-one" />
          <span className="events-hero-orbit events-hero-orbit-two" />

          <span className="events-hero-grid" />
        </div>

        <div className="events-hero-container">
          <div className="events-hero-content">
            <div className="events-eyebrow">
              <span className="events-eyebrow-line" />

              <span>
                EVENTS · INSIGHTS · CULTURE
              </span>
            </div>

            <h1 className="events-hero-title">
              Where ideas become
              <span> meaningful action.</span>
            </h1>

            <p className="events-hero-description">
              Explore the conversations, collaborations,
              events, and initiatives shaping the next
              generation of safer, smarter, and more
              resilient workplaces.
            </p>

            <div className="events-hero-actions">
              <button
                type="button"
                className="events-primary-button"
                onClick={scrollToLinkedIn}
              >
                <span>
                  See Latest Updates
                </span>

                <span
                  className="events-primary-button-icon"
                  aria-hidden="true"
                >
                  ↓
                </span>
              </button>

              <a
                href="https://www.linkedin.com/in/lisa-mcguire-05b49738/recent-activity/all/"
                target="_blank"
                rel="noopener noreferrer"
                className="events-secondary-link"
              >
                <span>
                  Visit LinkedIn
                </span>

                <span aria-hidden="true">
                  ↗
                </span>
              </a>
            </div>
          </div>

          {/* =================================================
              HERO CONTEXT CARD
          ================================================== */}

          <div className="events-hero-context">
            <div className="events-hero-context-top">
              <span className="events-context-status">
                <span />
                CONNECTED
              </span>

              <span className="events-context-number">
                01
              </span>
            </div>

            <div className="events-hero-context-copy">
              <span>
                GALAXYEDGE NETWORK
              </span>

              <h2>
                Ideas move further when
                the right people connect.
              </h2>

              <p>
                Industry conversations,
                global collaboration,
                applied research, and
                emerging safety innovation
                brought together in one place.
              </p>
            </div>

            <div className="events-context-tags">
              <span>
                Leadership
              </span>

              <span>
                Innovation
              </span>

              <span>
                Collaboration
              </span>
            </div>
          </div>
        </div>

        <div
          className="events-hero-bottom-line"
          aria-hidden="true"
        />
      </section>

      {/* =====================================================
          MAIN
      ====================================================== */}

      <main className="events-main">
        {/* ===================================================
            INTRO STRIP
        ==================================================== */}

        <section className="events-intro-strip">
          <div className="events-intro-strip-container">
            <div className="events-intro-item">
              <span className="events-intro-index">
                01
              </span>

              <div>
                <strong>
                  Global conversations
                </strong>

                <p>
                  Connecting ideas across
                  organizations, disciplines,
                  and industries.
                </p>
              </div>
            </div>

            <div className="events-intro-divider" />

            <div className="events-intro-item">
              <span className="events-intro-index">
                02
              </span>

              <div>
                <strong>
                  Practical insight
                </strong>

                <p>
                  Translating emerging
                  thinking into meaningful
                  workplace application.
                </p>
              </div>
            </div>

            <div className="events-intro-divider" />

            <div className="events-intro-item">
              <span className="events-intro-index">
                03
              </span>

              <div>
                <strong>
                  Continuous connection
                </strong>

                <p>
                  Follow current activity,
                  initiatives, and industry
                  engagement.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* ===================================================
            LINKEDIN LIVE FEED
        ==================================================== */}

        <section
          id="linkedin-live-feed"
          className="events-linkedin-section"
        >
          <div
            className="events-linkedin-background"
            aria-hidden="true"
          >
            <span className="events-linkedin-grid" />

            <span className="events-linkedin-glow events-linkedin-glow-one" />

            <span className="events-linkedin-glow events-linkedin-glow-two" />

            <span className="events-linkedin-orbit events-linkedin-orbit-one" />

            <span className="events-linkedin-orbit events-linkedin-orbit-two" />
          </div>

          <div className="events-section-container">
            {/* ===============================================
                LINKEDIN HEADING
            ================================================ */}

            <header className="events-linkedin-header">
              <div className="events-linkedin-heading-copy">
                <div className="events-section-kicker">
                  <span />

                  <p>
                    LATEST FROM LINKEDIN
                  </p>
                </div>

                <h2>
                  Stay connected to
                  <span> what we're doing.</span>
                </h2>

                <p className="events-linkedin-description">
                  Follow the latest insights,
                  collaborations, events,
                  research, and occupational
                  health and safety conversations
                  from Lisa McGuire.
                </p>
              </div>

              <div className="events-linkedin-status-card">
                <div className="events-linkedin-status-top">
                  <div className="events-linkedin-logo">
                    in
                  </div>

                  <span>
                    LINKEDIN FEED
                  </span>
                </div>

                <div className="events-linkedin-status-live">
                  <span className="events-linkedin-live-dot" />

                  <div>
                    <strong>
                      Auto-updating
                    </strong>

                    <p>
                      Connected to the
                      current LinkedIn feed
                    </p>
                  </div>
                </div>
              </div>
            </header>

            {/* ===============================================
                ELFSIGHT
            ================================================ */}

            <div className="events-linkedin-stage">
              <div className="events-linkedin-stage-top">
                <div>
                  <span className="events-stage-label">
                    CURRENT ACTIVITY
                  </span>

                  <p>
                    Latest LinkedIn updates
                  </p>
                </div>

                <a
                  href="https://www.linkedin.com/in/lisa-mcguire-05b49738/recent-activity/all/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="events-linkedin-open-link"
                >
                  <span>
                    Open LinkedIn
                  </span>

                  <span aria-hidden="true">
                    ↗
                  </span>
                </a>
              </div>

              <div className="events-linkedin-widget-shell">
                {/* ===========================================
                    REAL LINKEDIN FEED
                ============================================ */}

                <div
                  className="elfsight-app-2a4ce790-0890-4b42-b88a-74f0cb4cac95"
                  data-elfsight-app-lazy=""
                ></div>
              </div>

              <div className="events-linkedin-stage-footer">
                <div className="events-auto-update-note">
                  <span
                    className="events-auto-update-icon"
                    aria-hidden="true"
                  >
                    ↻
                  </span>

                  <div>
                    <strong>
                      Automatically synchronized
                    </strong>

                    <p>
                      New eligible LinkedIn posts
                      can appear here without
                      manually editing this page.
                    </p>
                  </div>
                </div>

                <div className="events-feed-source">
                  <span>
                    SOURCE
                  </span>

                  <strong>
                    Lisa McGuire · LinkedIn
                  </strong>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ===================================================
            DISCOVER
        ==================================================== */}

        

        {/* ===================================================
            FINAL CTA
        ==================================================== */}

        <section className="events-final-section">
          <div
            className="events-final-background"
            aria-hidden="true"
          >
            <span className="events-final-glow" />
            <span className="events-final-orbit" />
          </div>

          <div className="events-final-container">
            <div className="events-section-kicker events-section-kicker-centered">
              <span />

              <p>
                STAY CONNECTED
              </p>
            </div>

            <h2>
              Be part of the
              <span> conversation.</span>
            </h2>

            <p>
              Follow GalaxyEDGE Safety for
              new insights, collaborations,
              initiatives, and upcoming
              opportunities to connect.
            </p>

            <div className="events-final-actions">
              <a
                href="https://www.linkedin.com/in/lisa-mcguire-05b49738/recent-activity/all/"
                target="_blank"
                rel="noopener noreferrer"
                className="events-primary-link"
              >
                <span>
                  Follow on LinkedIn
                </span>

                <span
                  className="events-primary-link-icon"
                  aria-hidden="true"
                >
                  ↗
                </span>
              </a>

              <a
                href="/contact"
                className="events-final-contact-link"
              >
                Contact GalaxyEDGE
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}